/**
 * Chat-Text mit anklickbaren Links. Jeder http(s)-Link öffnet in einem neuen Tab
 * (`target="_blank"`, `rel="noopener noreferrer"`) — Antoine, 26.10.2026: der OpenTable-Link
 * muss überall, auch in der Antwort des Assistenten, in einem neuen Tab aufgehen.
 */
import { Fragment } from "react";

const LINK = /(https?:\/\/[^\s<>"]+)/g;

export function ChatText({ text }: { text: string }) {
  const teile = text.split(LINK);
  return (
    <>
      {teile.map((teil, i) => {
        if (i % 2 === 0) return <Fragment key={i}>{teil}</Fragment>;
        // Satzzeichen am Ende gehören nicht zum Link.
        const m = /^(.*?)([.,;:!?)\]]*)$/.exec(teil);
        const url = m?.[1] ?? teil;
        const rest = m?.[2] ?? "";
        return (
          <Fragment key={i}>
            <a href={url} target="_blank" rel="noopener noreferrer" className="break-all text-primary underline">
              {url}
            </a>
            {rest}
          </Fragment>
        );
      })}
    </>
  );
}
